import React from 'react'
import ReactDOM from 'react-dom'
import Root from './containers/root'
// import registerServiceWorker from './registerServiceWorker'
require('es6-promise').polyfill()
const log = require('debug')('app:index')

log('boot 🚀')

ReactDOM.render(
  <Root />,
  document.getElementById('root')
)
// @NOTE: disabling service worker since we cannot control cache for service worker file
// easily on dokku (service worker cache needs to be shorter then other files).
// If we would still use the service worker, cache would be very hard to break upon new versions.
// registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js